export default __webpack_public_path__ + "static/neograft-machine-9ba6cc1daee70aa86e45bc05347477db.png";